import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";
import ReferenceBookFileMeanings
    from "@/pages/ReferenceBooks/Lists/LaboratoryClarifications/FileMeanings/ReferenceBookFileMeanings";

const ReferenceBookLaboratoryQuestionsStatuses = lazy(() => import("@/pages/ReferenceBooks/Lists/LaboratoryClarifications/LaboratoryQuestionsStatuses/ReferenceBookLaboratoryQuestionsStatuses"));
const ReferenceBookTemplateQuestions = lazy(() => import("@/pages/ReferenceBooks/Lists/LaboratoryClarifications/TemplateQuestions/ReferenceBookTemplateQuestions"));
const ReferenceBookAnswerTypeRules = lazy(() => import("@/pages/ReferenceBooks/Lists/LaboratoryClarifications/AnswerTypeRules/ReferenceBookAnswerTypeRules"));
const ReferenceBookEditAnswerTypeRule = lazy(() => import("@/pages/ReferenceBooks/Lists/LaboratoryClarifications/AnswerTypeRules/ReferenceBookEditAnswerTypeRule"));
const ReferenceBookCreateAnswerTypeRule = lazy(() => import("@/pages/ReferenceBooks/Lists/LaboratoryClarifications/AnswerTypeRules/ReferenceBookCreateAnswerTypeRule"));

const urlsConfig = new UrlsConfig();

export function referenceBookLaboratoryClarificationsRoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookLaboratoryQuestionsStatuses.to}
                 element={<ReferenceBookLaboratoryQuestionsStatuses/>}/>
          <Route path={urlsConfig.referenceBookTemplateQuestions.to}
                 element={<ReferenceBookTemplateQuestions/>}/>
          <Route path={urlsConfig.referenceBookAnswerTypeRules.to}
                 element={<ReferenceBookAnswerTypeRules/>}/>
          <Route path={`${urlsConfig.referenceBookEditAnswerTypeRule.to}/:id`}
                 element={<ReferenceBookEditAnswerTypeRule/>}/>
          <Route path={`${urlsConfig.referenceBookCreateAnswerTypeRule.to}`}
                 element={<ReferenceBookCreateAnswerTypeRule/>}/>
          <Route path={urlsConfig.referenceBookFileMeanings.to} element={<ReferenceBookFileMeanings/>}/>
      </>
    );
}
